import { Popover } from 'antd';
import { Edit, IconProps } from 'react-feather';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import './style.less';
import ActionIcon from '../ActionIcon';

interface Props {
  redirect?: string;
  iconProps?: IconProps;
  disabled?: boolean;
  popover?: string;
  size?: number;
}

const EditIcon: React.FC<Props> = ({
  popover,
  redirect,
  iconProps,
  disabled,
  size = 20,
}) => {
  const intl = useIntl();

  const icon = (
    <Edit
      {...iconProps}
      size={size}
      cursor={'pointer'}
      onClick={!disabled ? iconProps?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
        pointerEvents: disabled ? 'none' : undefined,
      }}
    />
  );

  return (
    <Popover
      content={
        popover || intl.formatMessage({ id: 'commons.list.action.button' })
      }
      className="edit-icon"
    >
      {redirect ? (
        <span
          style={{
            cursor: disabled ? 'not-allowed' : undefined,
          }}
        >
          <Link
            to={redirect}
            style={{
              pointerEvents: disabled ? 'none' : undefined,
            }}
          >
            {icon}
          </Link>
        </span>
      ) : (
        <ActionIcon disabled={disabled}>{icon}</ActionIcon>
      )}
    </Popover>
  );
};

export default EditIcon;
